import {reqWithToken} from './requestHelper';

export async function getForms(){
    return (await reqWithToken('api/pebooking/manage')).data;
}

export async function getNoDrewForms(month){
    return (await reqWithToken('api/pebooking/manage/nodrew', {
        params: {month}
    })).data;
}


export async function getDrewStatistic(month){
    return (await reqWithToken('api/pebooking/manage/drewStatistic', {
        params: {month}
    })).data;
}


export async function deleteForm(id){
    return (await reqWithToken('api/pebooking/manage',{
        params: {id},
        method: 'delete'
    })).data;
}


export async function tryDraw(params){
    return (await reqWithToken('api/pebooking/manage/trydraw',{
        params
    })).data;
}

export async function commitDraw(data){
    return (await reqWithToken('api/pebooking/manage/draw',{
        data,
        method: 'post'
    })).data;
}

export async function sendNoDrewMail(data){
    return (await reqWithToken('api/pebooking/manage/sendNoDrewMail',{
        data,
        method: 'post'
    })).data;
}

export async function addDrewManually(picks){
    return (await reqWithToken('api/pebooking/manage/addDrewManually',{
        data:{
            picks
        },
        method: 'post'
    })).data;
}